import React from 'react'
import './sign-up-success.scss'

class SignupSuccess extends React.Component {
  state = {}

  render () {
    const { name } = this.props
    return (
      <>
        <p className='slogan-text'>Hey, {name}</p>
        <div className='row maths-day-container'>
          <div class='maths-day-description signup-success-description'>
            <p>
              Your profile is successfully created and is under review. <br />
              We will notify you over email as soon as your profile is approved.
            </p>
            <p>See ya!</p>
          </div>
        </div>
      </>
    )
  }
}

export default SignupSuccess
